import TutorReviewsList from './TutorReviewsList';

export default TutorReviewsList;
